// extracted by mini-css-extract-plugin
module.exports = {"container":"Tag_container__1mrhh","tagIcon":"Tag_tagIcon__ZFZ3I","text":"Tag_text__dy0a6","closeIcon":"Tag_closeIcon__3Vthy"};